import { render, staticRenderFns } from "./ticketAssociativeClassification.vue?vue&type=template&id=656f1be8&scoped=true"
import script from "./ticketAssociativeClassification.vue?vue&type=script&lang=js"
export * from "./ticketAssociativeClassification.vue?vue&type=script&lang=js"
import style0 from "./ticketAssociativeClassification.vue?vue&type=style&index=0&id=656f1be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656f1be8",
  null
  
)

export default component.exports